/**
 * Allys Property Map Card
 * 
 * Theme-specific wrapper for PropertyMapCard with Allys branding
 * Provides Phosphor icons and Allys colors to the core component
 */

'use client';

import { ArrowsOut, Bathtub, Bed } from '@phosphor-icons/react';
import { PropertyMapCard } from '../../../../src/components/properties/PropertyMapCard';
import type { Property } from '../../../../src/lib/api/clients/properties';

export interface AllysPropertyMapCardProps {
  property: Property;
  locationName?: string;
  labels?: {
    bedrooms?: string;
    bathrooms?: string;
    area?: string;
    viewDetails?: string;
  };
  href?: string;
  className?: string;
  isSelected?: boolean;
}

/**
 * AllysPropertyMapCard - Allys-themed wrapper for core PropertyMapCard
 * Provides Phosphor icons with Allys navy and gold colors, and Inter font styling
 */
export function AllysPropertyMapCard({
  property,
  locationName,
  labels,
  href,
  className = '',
  isSelected = false,
}: AllysPropertyMapCardProps) {
  return (
    <PropertyMapCard
      property={property}
      {...(locationName && { locationName })}
      {...(labels && { labels })}
      {...(href && { href })}
      isSelected={isSelected}
      className={`font-inter border-2 ${
        isSelected 
          ? 'border-[#BBA339] shadow-lg ring-1 ring-[#BBA339]/20' 
          : 'border-gray-100 hover:border-[#BBA339]/30 hover:shadow-md'
      } transition-all duration-200 ${className}`}
      icons={{
        bedroom: Bed,
        bathroom: Bathtub,
        area: ArrowsOut,
      }}
      iconColors={{
        bedroom: '#243462', // Allys Navy
        bathroom: '#BBA339', // Allys Gold
        area: '#6B7280', // Neutral Gray
      }}
      textStyles={{
        location: "text-xs text-gray-500 mb-1 truncate font-medium",
        title: "text-base font-bold text-[#243462] mb-1 line-clamp-1",
        price: "text-lg font-extrabold text-[#BBA339] mb-2",
        details: "flex items-center gap-3 text-sm text-gray-700 font-medium",
      }}
    />
  );
}

